import createReducer from "../../createReducer";
import { integrationStatusesHandlers } from "../handlers";
import { IIntegrationStatusesState } from "../types";

const integrationStatusesInitialState: IIntegrationStatusesState = {
    isLoading: false,
    error: null,
    statuses: null,
};

export default createReducer(integrationStatusesInitialState, integrationStatusesHandlers);
